import {ItemQuantitiesSelection, SelectionStore} from "./selectionReducer"

function getSelectionStore(state): SelectionStore {
    return state.selectionReducer as SelectionStore
}
export function getCustomerIdSelection(state): Set<string> {
    return getSelectionStore(state).customerIdSelection
}
export function getOptionalItemSelection(state): string[] {
    return getSelectionStore(state).optionalItemSelection
}
export function getItemQuantities(state): ItemQuantitiesSelection[] {
    return getSelectionStore(state).itemQuantities
}
export function getMultiChoiceSelection(state): string[] {
    return getSelectionStore(state).multiChoiceItemSelection
}
export function getPaymentType(state): string {
    return getSelectionStore(state).paymentType
}
export function getPaymentNotes(state): string {
    return getSelectionStore(state).paymentNote
}
export function useDefaultCardOnFile(state): boolean {
    return getSelectionStore(state).useDefaultCardOnFile
}
export function getSubtotalAmount(state): number {
    return getSelectionStore(state).subtotal
}
export function getTotalAmount(state): number {
    return getSelectionStore(state).total
}
export function getIgnorePaymentStep(state): boolean {
    return getSelectionStore(state).ignorePaymentStep
}



// WEBPACK FOOTER //
// ./src/state/selection/selectionSelectors.ts